import { render, staticRenderFns } from "./ClientTableDetails.vue?vue&type=template&id=250ee564"
import script from "./ClientTableDetails.vue?vue&type=script&lang=js"
export * from "./ClientTableDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports